export class PreQualificationData{
    coBorrowerPresent : string;//Save what user selects from UI for the question Do you want to add a co-applicant ?
    individualDetails : IndividualDetails[];
    annualIncomeCombined :string;
    constructor(){
        this.individualDetails = [];
    }
}
export class IndividualDetails{
    personalDetails : PersonalDetails;
    residentDetails : ResidentDetails;
    creditBureauConsent :string;
    borrower:string//Save whether primary or secondary
}

export class PersonalDetails{
    constructor(){
    }
    firstName:string;
    middleName:string;
    lastName:string;
    dateOfBirth:string;
    email:string;
    phoneNum:string;
}
export class ResidentDetails{
    constructor(){
    }
    addressLine1 :string;
    addressLine2 :string;
    city:string;
    province:string;
    postalCode:string;
}
